function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_26912_10277)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.7422 0H2.25781C1.28855 0 0.5 0.788555 0.5 1.75781V13.125V15.0781C0.5 16.0474 1.28855 16.8359 2.25781 16.8359H7.72656V18.8281H6.75C6.42641 18.8281 6.16406 19.0905 6.16406 19.4141C6.16406 19.7377 6.42641 20 6.75 20H14.25C14.5736 20 14.8359 19.7377 14.8359 19.4141C14.8359 19.0905 14.5736 18.8281 14.25 18.8281H13.2734V16.8359H18.7422C19.7114 16.8359 20.5 16.0474 20.5 15.0781V13.125V1.75781C20.5 0.788555 19.7114 0 18.7422 0ZM1.67188 1.75781C1.67188 1.43473 1.93473 1.17188 2.25781 1.17188H18.7422C19.0653 1.17188 19.3281 1.43473 19.3281 1.75781V12.5391H1.67188V1.75781ZM12.1016 18.8281H8.89844V16.8359H12.1016V18.8281ZM19.3281 15.0781C19.3281 15.4012 19.0653 15.6641 18.7422 15.6641H2.25781C1.93473 15.6641 1.67188 15.4012 1.67188 15.0781V13.7109H19.3281V15.0781Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.875 2.53906H3.625C3.30141 2.53906 3.03906 2.80141 3.03906 3.125V5.625C3.03906 5.94859 3.30141 6.21094 3.625 6.21094H9.875C10.1986 6.21094 10.4609 5.94859 10.4609 5.625V3.125C10.4609 2.80141 10.1986 2.53906 9.875 2.53906ZM9.28906 5.03906H4.21094V3.71094H9.28906V5.03906Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.375 2.53906H12.375C12.0514 2.53906 11.7891 2.80141 11.7891 3.125V10.625C11.7891 10.9486 12.0514 11.2109 12.375 11.2109H17.375C17.6986 11.2109 17.9609 10.9486 17.9609 10.625V3.125C17.9609 2.80141 17.6986 2.53906 17.375 2.53906ZM16.7891 10.0391H12.9609V3.71094H16.7891V10.0391Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.875 7.53906H3.625C3.30141 7.53906 3.03906 7.80141 3.03906 8.125C3.03906 8.44859 3.30141 8.71094 3.625 8.71094H9.875C10.1986 8.71094 10.4609 8.44859 10.4609 8.125C10.4609 7.80141 10.1986 7.53906 9.875 7.53906Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.875 10.0391H3.625C3.30141 10.0391 3.03906 10.3014 3.03906 10.625C3.03906 10.9486 3.30141 11.2109 3.625 11.2109H9.875C10.1986 11.2109 10.4609 10.9486 10.4609 10.625C10.4609 10.3014 10.1986 10.0391 9.875 10.0391Z",
  fill: "#23335B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_26912_10277"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(0.5)"
})));

var SvgOverview = function SvgOverview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOverview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/overview.a75de29e.svg";
export { ForwardRef as ReactComponent };